import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, ThemeProvider, Typography, createTheme, styled } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { T, useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import DefaultInput from '../DefaultInput'
import { useEffect } from 'react'
import storeCountry from 'GlobalStores/Cores/County/StoreCountry'
import axios from 'axios'
import httpHelper from 'Services/HttpHelper'
import Loader from '../Assets/LoaderForModal.svg'
import { ServerEnv } from 'Configs/ServerEnv'

let DialogWrapper = Dialog

const ModalSearch = observer(props => {
    const [open, setOpen] = useState(false)
    const [address, setAddress] = useState([])
    const [focusAddress, setFocusAddress] = useState(null)
    const [loading, setLoading] = useState(null)

    const [themeStyle, setThemeStyle] = useState(ModalSearchTheme)

    const onOkThenSearch = () => {
        GetAddressFromZipcode(props.value)
    }

    useEffect(() => {
        // const country = storeCountry.CountryLowerCase()
        DialogWrapper = DefaultDialogWrapper
    }, [])

    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden !important'
            document.getElementById('root').style.touchAction = 'none'
            document.getElementsByTagName('body')[0].style.touchAction = 'none'
        } else {
            document.body.style.overflow = ''
            document.getElementById('root').style.touchAction = ''
            document.getElementsByTagName('body')[0].style.touchAction = ''
        }
    }, [open])

    useEffect(() => {
        return () => {
            if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
                let body = document.getElementById('root')
                if (body) {
                    body.style.position = 'relative'
                }
            }
        }
    }, [])

    const GetAddressFromZipcode = async values => {
        if (values.length > 0) {
            setLoading(true)
            setTimeout(() => { }, 1000)
            const country3 = storeCountry.Country3()
            const url = `${ServerEnv.MemberCalls2()}/unishop-fn-misc/city/search?country_code=${country3}&keyword=${values}`
            let temp = []
            try {
                const { data, status } = await axios.get(httpHelper.Proxy({ originalUrl: url }))
                if (status === 200) {
                    setAddress(data.data)
                } else {
                    setAddress([])
                }
            } catch (e) {
                if (e.response.data.errors) {
                    // inputCallback(values)
                }
            } finally {
                setLoading(false)
            }
        }
    }

    const handleSelectAddressl = () => {
        props.onSet(focusAddress)
        setOpen(false)
        // console.log('Now we should use this as ADDR => ', focusAddress)
    }

    return (
        <ThemeProvider theme={themeStyle}>
            <Stack id="dialog-modal">
                <DefaultInput
                    type="zipSearch"
                    value={props.value}
                    label={props.label}
                    endAdornmentToggle={status => {
                        setAddress([])
                        setOpen(status)
                    }}
                    onChange={props.onChange}
                />
                <DialogWrapper disablePortal open={open} onClose={() => setOpen(false)} scroll="paper">
                    <DialogTitle><T>search_address</T></DialogTitle>
                    <DialogContent
                        sx={{
                            padding: '10px !important'
                        }}>
                        {address.length ? (
                            address.map((addr, addrIndex) => {
                                return (
                                    <ZipDisplay key={`zipSearch` + addrIndex} onClick={() => setFocusAddress(addr)} focused={addr.id === focusAddress?.id}>
                                        <Typography variant="h5">{addr.zip}</Typography>
                                        <Typography variant="h5">{addr.search_address_native}</Typography>
                                    </ZipDisplay>
                                )
                            })
                        ) : (
                            <DefaultInput
                                type="tel"
                                label={null}
                                value={props.value}
                                onChange={e => {
                                    props.onChange(e)
                                }}
                            />
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Box width={'100%'} display={'flex'} justifyContent={'center'} borderRight={'1px solid #e3e8ed'}>
                            <Button onClick={() => setOpen(false)} disableRipple disableFocusRipple sx={{ width: '100% !important' }}>
                                <T>cancel</T>
                            </Button>
                        </Box>
                        <Box width={'100%'} display={'flex'} justifyContent={'center'} ml="0px!important">
                            <Button
                                disabled={!!!props.value}
                                onClick={address.length ? handleSelectAddressl : onOkThenSearch}
                                className="ok-button"
                                disableRipple
                                disableFocusRipple
                                sx={{ width: '100% !important' }}>
                                {loading ? <Spiner src={Loader} alt="Loading" /> : <T>ok</T>}

                            </Button>
                        </Box>
                    </DialogActions>
                </DialogWrapper>
            </Stack>
        </ThemeProvider>
    )
})

const Spiner = styled('img')({
    animation: 'rotation 1s infinite linear',
    '@keyframes rotation': {
        '0%': {
            transform: 'rotate(0deg)'
        },
        '100%': {
            transform: 'rotate(359deg)'
        }
    }
})

const ZipDisplay = styled(Box)(({ theme, focused }) => {
    return {
        border: focused ? '2px solid rgb(153, 188, 223)' : '1px solid rgb(229, 238, 247)',
        borderRadius: '8px',
        cursor: 'pointer',
        padding: '15px',
        margin: '10px 0',
        h5: {
            fontSize: '14px',
            color: focused ? 'rgb(0, 59, 111)' : 'rgb(147, 170, 191)',
            ':first-of-type': {
                fontSize: '18px',
                color: focused ? 'rgb(0, 59, 111)' : 'rgb(51, 98, 140)'
            }
        }
    }
})
const DefaultDialogWrapper = styled(Dialog)(({ theme }) => {
    return {
        '.MuiDialog-paper': {
            '.MuiDialogTitle-root': {
                padding: '5px 10px',
                color: '#22aaec'
                // display: 'none !important'
            }
        }
    }
})

const ModalSearchTheme = createTheme({
    typography: {
        fontFamily: 'Prompt, sans-serif!important',
        option: {
            fontSize: '1.833333em',
            fontFamily: 'Prompt, sans-serif!important',
            padding: '0.5em'
        }
    },
    components: {
        MuiDialog: {
            defaultProps: {
                PaperComponent: 'div'
            },
            styleOverrides: {
                paper: {
                    backgroundColor: '#f7f7f7',
                    width: '325px !important',
                    borderRadius: '7px'
                }
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: '5px 10px',
                    zIndex: '2'
                }
            }
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    justifyContent: 'center',
                    border: '1px solid #e3e8ed',
                    padding: 0
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    with: '100% !important',
                    fontFamily: 'Prompt, sans-serif!important',
                    color: '#22aaec',

                    '&:hover': {
                        backgroundColor: 'transparent'
                    },
                    '&.ok-button': {
                        fontWeight: 'bold'
                    }
                }
            }
        }
    }
})

export default ModalSearch
